<template>
  <div>
    <layout>
      <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="account">
          <el-input class="input" v-model="dataForm.account" placeholder="输入手机号码">
            <template slot="prepend">
              手机号
              <span class="after"></span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-bottom:0">
          <el-input class="input" type="password" v-model="dataForm.password" placeholder="输入密码">
            <template slot="prepend">
              密码
              <span class="after"></span>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="captcha">
          <el-input class="input" v-model="dataForm.captcha" placeholder="输入验证码">
            <template slot="prepend">
              验证码
              <span class="after"></span>
            </template>
            <template slot="append">
            </template>
          </el-input>
          <el-image @click="getCode" style="width: 94.5px; height: 54px;margin-left:9.5px;" :src="codeUrl" fit="fill"></el-image>
        </el-form-item> -->
        <el-form-item prop="name">
          <el-button type="primary" class="submit" @click="login" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="flex">
        <el-link @click="getLinkFromDevice">
          <i class="el-icon-mobile"></i> 下载APP
        </el-link>
        <el-link href="/#/forgetPwd">忘记密码?</el-link>
      </div>
      <!-- <div class="pdt-40">
        <el-divider>其他登录方式</el-divider>
        <el-row>
          <el-col :span="5" class="icon-title">
            <el-link class="link" :underline="false">
              <i class="el-icon-chat-dot-round"></i>
              <div>微信登录</div>
            </el-link>
          </el-col>
          <el-col :span="5" class="icon-title" v-if="codeShow">
            <el-link class="link" :underline="false" @click="codeShow = false">
              <i class="el-icon-user"></i>
              <div>账号登录</div>
            </el-link>
          </el-col>
          <el-col :span="5" class="icon-title" v-if="!codeShow">
            <el-link class="link" :underline="false" @click="codeShow = true">
              <i class="el-icon-full-screen"></i>
              <div>扫码登录</div>
            </el-link>
          </el-col>
        </el-row>
      </div>-->
      <div v-if="codeShow" class="codebox">
        <div>
          <el-image style="width: 300px; height: 300px" fit="cover" :src="url"></el-image>
          <div class="codeTitle">使用同正APP扫码登录</div>
        </div>
      </div>
    </layout>
  </div>
</template>
<script>
import Layout from "../layout";

import {v4 as uuidv4} from "uuid";

export default {
  name: "login",
  components: {
    Layout
  },
  data() {
    let checkAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      callback();
    };
    let checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    let checkCaptcha = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
      callback();
    };
    return {
      rules: {
        account: [{validator: checkAccount, trigger: "blur"}],
        password: [{validator: checkPwd, trigger: "blur"}],
        captcha: [{validator: checkCaptcha, trigger: "blur"}]
      },
      dataForm: {
        account: "",
        password: "",
        captcha: "",
        uuid: ""
      },
      checked: false,
      codeShow: false,
      url:
          "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      codeUrl: "",
      loading: false
    };
  },
  created() {

    this.getCode();
  },
  methods: {
    // 获取验证码
    getCode() {
      this.dataForm.uuid = uuidv4();
      this.codeUrl =
          process.env.VUE_APP_BASE_API +
          "/captcha.jpg?uuid=" +
          this.dataForm.uuid;
    },
    // 登录
    login() {


      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
              .dispatch("user/login", this.dataForm)
              .then(res => {
                console.log(res);
                this.$router.replace({path: this.$route.query.redirect || "/"});
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
                this.getCode();
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //区分手机和PC
    getLinkFromDevice() {
      if (this._isMobile()) {
        this.$router.replace({path: 'm_appDown'});
      } else {
        this.$router.replace({path: 'appDown'});
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 27px;
}

.el-form {
  /deep/ .el-form-item:nth-of-type(3) {
    /deep/ .el-form-item__content {
      display: flex;

      .input {
        width: 328px;
      }
    }
  }
}

.input {
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 2px;

  /deep/ .el-input-group__append {
    background-color: transparent;
    border: none;
    padding: 0;
    font-size: 0;
  }

  /deep/ .el-input-group__prepend {
    height: 54px;
    background-color: transparent;
    border: none;
    position: relative;
    color: #9fb2e3;
    width: 56px;
    font-size: 19px;

    .after {
      position: absolute;
      top: 16px;
      right: 0;
      width: 1px;
      height: 20px;
      background-color: #e9e9e9;
    }
  }

  /deep/ .el-input__inner {
    background-color: transparent;
    border: none;
    height: 54px;
    font-size: 19px;
  }
}

.submit {
  width: 100%;
  height: 63px;
  margin-top: 16px;
  font-size: 19.8px;
  background: #3963ff;
  border: none;
  box-shadow: 8px 15px 15px #cdd8ff;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16.2px;

  a:nth-of-type(2) {
    color: #3963ff;
  }
}

.pdt-40 {
  padding-top: 40px;
}

.icon-title {
  text-align: center;
  margin-top: 20px;

  .link {
    font-size: 26px;

    div {
      font-size: 12px;
    }
  }
}

.codebox {
  position: absolute;
  width: 100%;
  height: 460px;
  background-color: #fff;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .codeTitle {
    text-align: center;
    color: #666;
    padding-top: 20px;
  }
}
</style>
